var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9673 24L5.30065 18.7V10.7L0.333984 8L14.9673 0L29.6673 8V18.5667H27.6673V9.16667L24.634 10.7V18.7L14.9673 24ZM14.9673 13.7333L25.4673 8L14.9673 2.36667L4.53398 8L14.9673 13.7333ZM14.9673 21.7333L22.634 17.5V11.9L14.9673 16L7.30065 11.8333V17.5L14.9673 21.7333Z",
    fill: "#1C1C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.d23cad44822dda33ab341873f192def9.svg";
export { ForwardRef as ReactComponent };